import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { oqulyqtarApi } from '@api/oqulyqtarApi/api';
import { editorApi } from '@api/editorApi/api';
import filterReducer from './reducers/filterSlice';
import notificationReducer from './reducers/notificationSlice';
import authReducer from './reducers/authSlice.js'
import userReducer from './reducers/userSlice.js'


const rootReducer = combineReducers({
    [oqulyqtarApi.reducerPath]: oqulyqtarApi.reducer,
    [editorApi.reducerPath]: editorApi.reducer,
    filter: filterReducer,
    notification: notificationReducer,
    auth: authReducer,
    user: userReducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(oqulyqtarApi.middleware).concat(editorApi.middleware)
});

export type AppDispatch = typeof store.dispatch;
